import { render, staticRenderFns } from "./BattleBracketsRenderer.vue?vue&type=template&id=12f48734&scoped=true"
import script from "./BattleBracketsRenderer.vue?vue&type=script&lang=js"
export * from "./BattleBracketsRenderer.vue?vue&type=script&lang=js"
import style0 from "./BattleBracketsRenderer.vue?vue&type=style&index=0&id=12f48734&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f48734",
  null
  
)

export default component.exports